module.exports = __webpack_public_path__ + "img/legal.e5af6d20.png";